import { ArrowUpRight } from "lucide-react";
import { LogoMark } from "@/components/LogoMark";
import { scrollToId } from "@/lib/scroll";
import { useBooking } from "@/lib/bookingStore";

const LINKS = [
    { label: "Services", target: "#services", testId: "nav-link-services" },
    { label: "Process", target: "#process", testId: "nav-link-process" },
    { label: "About", target: "#about", testId: "nav-link-about" },
    { label: "Contact", target: "#contact", testId: "nav-link-contact" },
];

export const Navbar = () => {
    const openBooking = useBooking((s) => s.openBooking);
    return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/10 bg-black/40 backdrop-blur-xl">
        <nav className="flex h-16 items-center justify-between px-6 md:h-20 md:px-12">
            <button
                data-testid="nav-logo"
                onClick={() => scrollToId("#top")}
                className="group flex items-center gap-2.5 font-display text-xl font-black tracking-tight text-white md:text-2xl"
            >
                <LogoMark
                    size={20}
                    className="text-white transition-transform duration-500 ease-out group-hover:rotate-90"
                />
                RaRe<span className="align-super text-[0.5em] text-white/40">®</span>
            </button>
            <div className="hidden items-center gap-10 md:flex">
                {LINKS.map((link) => (
                    <button
                        key={link.target}
                        data-testid={link.testId}
                        onClick={() => scrollToId(link.target)}
                        className="font-mono-x text-xs uppercase tracking-[0.2em] text-zinc-400 transition-colors duration-300 hover:text-white"
                    >
                        {link.label}
                    </button>
                ))}
            </div>
            <button
                data-testid="nav-book-call-button"
                onClick={openBooking}
                className="group inline-flex items-center gap-2 rounded-full bg-white px-5 py-2.5 font-display text-sm font-bold text-[#050505] transition-transform duration-300 hover:scale-105 md:px-6 md:py-3"
            >
                Book a Call
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
            </button>
        </nav>
    </header>
    );
};
